<template>
  <v-container
    fluid
  >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        hide-details
        class="mb-2"
      />
      <v-btn
        color="primary"
        class="ms-2"
        @click="newItem()"
      >
        <i class="fas fa-layer-plus fa-lg me-2" />
        {{ $t('new') }}
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="dataRows"
      :items-per-page="tableCPP"
      :search="search"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn-toggle class="me-2">
          <v-btn
            fab
            x-small
            class="indigo"
            @click="showItem(item)"
          >
            <i
              class="fal fa-eye fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="warning"
            @click="editItem(item)"
          >
            <i
              class="fal fa-pencil fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="error"
            @click="deleteConfirm(item)"
          >
            <i
              class="fal fa-trash-alt fa-lg"
            />
          </v-btn>
        </v-btn-toggle>
      </template>
      <template v-slot:item.status_text="{ item }">
        <v-chip
          :color="getStatusColor(item.status_text)"
        >
          {{ $t(item.status_text) }}
        </v-chip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      :persistent="true"
      :internal-activator="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <span
            class="headline"
          >
            {{ formTitle }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="10"
              >
                <v-text-field
                  v-model="editedItem.title"
                  :label="$t('title')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="2"
              >
                <v-switch
                  v-model="editedItem.status"
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2">{{ $t('status') }}</span>
                  </template>
                </v-switch>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  v-model="editedItem.category"
                  :label="$t('category')"
                  :items="categoryRows"
                  item-text="display"
                  item-value="dbitem"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  v-model="editedItem.kind"
                  :label="$t('kind')"
                  :items="kindRows"
                  item-text="display"
                  item-value="dbItem"
                />
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="4"
              >
                <v-subheader>{{ $t('difficulty') }}</v-subheader>
                <v-slider
                  v-model="editedItem.difficulty"
                  class="align-center"
                  :max="max"
                  :min="min"
                  hide-details
                >
                  <template
                    v-slot:append
                  >
                    <v-text-field
                      v-model="editedItem.difficulty"
                      class="mt-0 pt-0"
                      hide-details
                      single-line
                      type="number"
                      style="width: 60px"
                    />
                  </template>
                </v-slider>
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.answer_option_1"
                  :label="$t('answer_option_1') + ' (' + $t('answer_true') + ')'"
                />
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.answer_option_2"
                  :label="$t('answer_option_2')"
                />
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.answer_option_3"
                  :label="$t('answer_option_3')"
                />
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.answer_option_4"
                  :label="$t('answer_option_4')"
                />
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.score"
                  :label="$t('score')"
                />
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.hint"
                  :label="$t('hint')"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="btnLoadingSave"
            :disabled="btnLoadingSave"
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShow"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="4"
                sm="9"
                md="10"
              >
                <p>{{ $t('id') }} : <strong>{{ editedItem.id }}</strong></p>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="2"
              >
                <v-switch
                  v-model="editedItem.status"
                  disabled
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2 text-no-wrap">{{ $t('status') + ` : ` + $t(editedItem.status_text) }}</span>
                  </template>
                </v-switch>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('title') }} : <strong>{{ editedItem.title }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('order') }} : <strong>{{ editedItem.order }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('description') }} : </p>
                <ckeditor
                  v-model="editedItem.description"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('max_score_end') }} : </p>
                <ckeditor
                  v-model="editedItem.max_score_end"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('approved_score_end') }} : </p>
                <ckeditor
                  v-model="editedItem.approved_score_end"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('rejected_score_end') }} : </p>
                <ckeditor
                  v-model="editedItem.rejected_score_end"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('created_at') }} : <strong>{{ editedItem.created_at }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('updated_at') }} : <strong>{{ editedItem.updated_at }}</strong></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-bottom-sheet
        v-model="deleteSheet"
        persistent
        inset
      >
        <v-sheet
          class="text-center"
          height="200px"
        >
          <v-btn
            class="mt-6"
            color="error"
            :loading="btnLoadingDelete"
            :disabled="btnLoadingDelete"
            @click="deleteItem(editedItem)"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn
            class="mt-6 ms-2"
            color="green"
            @click="deleteSheet = !deleteSheet"
          >
            {{ $t('close') }}
          </v-btn>
          <div class="py-3">
            {{ $t('permanently_delete?') }} {{ $t('you_can_not_undo.') }}
            <p class="pt-3">
              {{ $t('id') }} : <strong>{{ editedItem.id }}</strong> ,
              {{ $t('title') }} : <strong>{{ editedItem.title }}</strong>
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  export default {
    name: 'Operations',
    data () {
      return {
        headers: [],
        dataRows: [],
        dynamicColumns: [],
        categoryRows: [],
        kindRows: [
          { dbItem: 1, display: this.$t('test') },
          { dbItem: 2, display: this.$t('dissection') },
          { dbItem: 3, display: this.$t('file') },
        ],
        tableCPP: 0,
        min: 1,
        max: 10,
        search: '',
        loading: true,
        dialog: false,
        dialogShow: false,
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        formTitle: '',
        deleteSheet: false,
        btnLoadingDelete: false,
        btnLoadingSave: false,
        snackbar: false,
        snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
        snackbarText: '',
        editor: ClassicEditor,
        editorConfig: {
          language: {
            ui: 'en',
            content: 'fa',
          },
          toolbar: [
            'undo',
            'redo',
            'fontColor',
            'fontBackgroundColor',
            'fontSize',
            '|',
            'bold',
            'italic',
            'underline',
            'removeFormat',
            'alignment',
            'bulletedList',
            'numberedList',
            'horizontalLine',
            '|',
            'link',
            'imageUpload',
            'insertTable',
            'mediaEmbed',
          ],
          image: {
            toolbar: [
              'imageTextAlternative',
              'imageStyle:full',
              'imageStyle:side',
            ],
          },
          table: {
            contentToolbar: [
              'tableColumn',
              'tableRow',
              'mergeTableCells',
            ],
          },
        },
      }
    },
    async created () {
      await this.getCategoryData()
      await this.getData()
      await this.getOptions()
      await this.getDynamicColumns()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showByTitle', {
          title: 'Questions-CPP',
        }).then(
          response => {
            const result = response.data.Option
            this.tableCPP = parseInt(result.value)
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': options/showByTitle|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showByTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getHeaders () {
        this.$http.post('options/showTableHeader', {
          title: 'Questions-TH-Operations',
        }).then(
          response => {
            const result = response.data.Option
            this.headers = []
            this.headers.push({ text: this.$t('id'), value: 'id' })
            result.forEach(o => {
              this.headers.push({
                text: this.$t((typeof this.dynamicColumns[o.value] !== 'undefined') ? this.dynamicColumns[o.value] : o.value),
                value: o.value,
              })
            })
            this.headers.push({ text: this.$t('actions'), value: 'actions', sortable: false })
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': options/showTableHeader|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showTableHeader|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getDynamicColumns () {
        this.$http.post('dynamicColumns/showByTable', {
          table: 'questions',
        }).then(
          response => {
            const result = response.data.DynamicColumns
            result.forEach(o => {
              this.dynamicColumns[o.column] = this.$t(o.title)
            })
            this.getHeaders()
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getData () {
        this.$http.post('questions/index').then(
          response => {
            this.dataRows = response.data.Questions
            this.editedItem = Object.assign({}, this.dataRows[0])
            const tempArray = []
            Object.keys(this.editedItem).forEach(function (item) {
              Object.assign(tempArray, { [item]: null })
            })
            this.defaultItem = tempArray
            this.loading = false
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': questions/index|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': questions/index|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getCategoryData () {
        this.$http.post('questionCategories/index').then(
          response => {
            this.categoryRows = response.data.QuestionCategories
            const tempArray = []
            this.categoryRows.forEach(function (value) {
              tempArray.push({ dbitem: value.id, display: value.title })
            })
            this.categoryRows = tempArray
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': questionCategories/index|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': questionCategories/index|902'
          this.snackbar = true
          console.log(error)
        })
      },
      newItem () {
        this.formTitle = this.$t('new')
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = true
      },
      editItem (item) {
        this.formTitle = this.$t('edit')
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteConfirm (item) {
        this.editedItem = Object.assign({}, item)
        this.deleteSheet = true
      },
      showItem (item) {
        this.editedItem = Object.assign({}, item)
        this.dialogShow = true
      },
      deleteItem (item) {
        this.btnLoadingDelete = true
        this.$http.post('questions/delete', {
          id: item.id,
        }).then(
          response => {
            const index = this.dataRows.indexOf(this.dataRows.find(x => x.id === item.id))
            this.dataRows.splice(index, 1)
            this.deleteSheet = false
            this.btnLoadingDelete = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.btnLoadingDelete = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': questions/delete|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.btnLoadingDelete = false
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': questions/delete|902'
          this.snackbar = true
          console.log(error)
        })
      },
      save () {
        this.btnLoadingSave = true
        if (this.editedIndex > -1) {
          this.$http.post('questions/update', this.editedItem).then(
            response => {
              Object.assign(this.dataRows[this.editedIndex], this.editedItem)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_updated')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ': questions/update|901'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': questions/update|902'
            this.snackbar = true
            console.log(error)
          })
        } else {
          this.$http.post('questions/create', this.editedItem).then(
            response => {
              this.dataRows.push(response.data.Questions)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_inserted')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ': questions/create|901'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': questions/create|902'
            this.snackbar = true
            console.log(error)
          })
        }
      },
      close () {
        this.dialog = false
        this.dialogShow = false
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      },
      getStatusColor (text) {
        let returnColor
        switch (text) {
          case 'deactivate':
            returnColor = 'red'
            break
          case 'active':
            returnColor = 'green'
            break
          case 'locked':
            returnColor = 'purple'
            break
          case 'unknown':
            returnColor = 'yellow'
            break
          default:
            returnColor = 'yellow'
        }
        return returnColor
      },
    },
  }
</script>

<style scoped>

</style>
